var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#B2C8D8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38861 2H5V22H3.38861C3.07486 22 2.76419 21.9284 2.47434 21.7894C2.18448 21.6503 1.92112 21.4465 1.69931 21.1896C1.47749 20.9327 1.30157 20.6277 1.18158 20.292C1.06159 19.9564 0.999887 19.5966 1 19.2333V4.76568C0.999887 4.40245 1.06159 4.04276 1.18159 3.70715C1.30159 3.37154 1.47753 3.0666 1.69936 2.80976C1.92118 2.55292 2.18455 2.3492 2.4744 2.21026C2.76425 2.07132 3.07491 1.99987 3.38861 2ZM7 22V2H23V22H7ZM18.197 11.8648L19.7601 12.9689L20.1736 6.96687L14.9778 9.59304L16.5409 10.6972L15.0284 13.0249L11.8464 10.8146L8.83084 15.6048L10.5004 16.7477L12.4129 13.7079L15.5712 15.9021L18.197 11.8648Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon);
export default __webpack_public_path__ + "static/media/campaign-icon.23c3111e.svg";
export { ForwardRef as ReactComponent };